<template>
  <component :is="component" :termsData="termsData" :paginationData="paginationData" v-if="component" :termsType="termsType"/>
</template>

<script>
export default {
  name: "TermsListLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    listLayout: {},
    termsData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
    termsType: '',

  },
  data() {
    return {
      component: null,
    }
  },
  created() {
  },
  mounted() {
    this.listLoader();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/terms/list/${this.listLayout}`)
    },
  },
  methods: {
    listLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/terms/list/TermsListDefaultLayout')
          })
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>